<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import { usePermissions } from "@/auth/usePermissions";
import { useGetCanvassHouse } from "@/canvasses/canvassHousesCrud";
import type { Canvass } from "@/canvasses/types";
import BottomSheet from "@/components/BottomSheet.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import TabNav from "@/components/TabNav.vue";
import { RouterView, useRouter } from "vue-router";

const props = defineProps<{
  canvass: Canvass;
  houseId: number;
}>();

const { canvassHouse, getCanvassHouseStatus } = useGetCanvassHouse(
  props.canvass.id,
  props.houseId,
);

const router = useRouter();

function close() {
  void router.push({ name: "canvassFlowArea" });
}

const { me } = useGetMe();
const { canAccess } = usePermissions(me);
</script>

<template>
  <BottomSheet @close="close">
    <template #title>
      <template v-if="canvassHouse !== undefined">
        {{ canvassHouse.street }} {{ canvassHouse.houseNumber }}
      </template>
    </template>
    <template #subheading>
      <TabNav>
        <li>
          <RouterLink :to="{ name: 'canvassFlowHouseDetails' }">
            Haus
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'canvassFlowHouseConversations' }">
            Gespräche
          </RouterLink>
        </li>
        <li v-if="canAccess('canvassFlowContacts')">
          <RouterLink :to="{ name: 'canvassFlowHouseContacts' }">
            Kontakte
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'canvassFlowHouseComments' }">
            Kommentare
          </RouterLink>
        </li>
      </TabNav>
    </template>
    <HandleQueryStatus :query-status="getCanvassHouseStatus">
      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component
            :is="Component"
            :canvass="canvass"
            :canvass-house="canvassHouse"
          ></component>
        </KeepAlive>
      </RouterView>
    </HandleQueryStatus>
  </BottomSheet>
</template>
